import { getId, getProperty } from 'customer-data-objects/model/ImmutableModel';
import { DUE_DATE, RELATIVE_REMINDERS, REMINDERS, TITLE } from 'customer-data-objects/task/TaskPropertyNames';
import { useCallback, useMemo } from 'react';
import { NavMarker } from 'react-rhumb';
import { useHistory } from 'react-router-dom';
import { getDefaultTask } from 'task-forms-lib/utils/TaskDefaults';
import { FloatingAlertStore } from 'foundations-components/transitional/components/FloatingAlertList';
import { Panel } from 'foundations-components/transitional/components/Panel';
import { postTaskRecord } from '../../api/tasks';
import { useDispatch } from '../../context/Redux';
import { useOwnerId } from '../../hooks/auth';
import { useQueryParamString } from '../../hooks/useQueryParams';
import { useTaskDefaults } from '../../hooks/useTaskDefaults';
import { useActiveViewId } from '../../hooks/viewTabs';
import { addNewTask } from '../../redux/actions/tasksCRUD';
import { addError } from '../../tracking/errors';
import { triggerWootricSurvey } from '../../tracking/triggerWootricSurvey';
import { getGoToCreatedTaskAlert } from '../../utils/alerts';
import { viewLink } from '../../utils/links';
import TaskFormAsync from './TaskFormAsync';
import { useSearchRequestOptionsForView } from '../../hooks/tasksSearchResults';
import { jsx as _jsx } from "react/jsx-runtime";
const renderRhumbErrorMarker = () => /*#__PURE__*/_jsx(NavMarker, {
  name: "CREATE_TASK_PANEL_ERROR"
});
const CreateTaskPanel = () => {
  const history = useHistory();
  const queryParamsString = useQueryParamString();
  const activeViewId = useActiveViewId();
  const {
    searchKey
  } = useSearchRequestOptionsForView(activeViewId);
  const dispatch = useDispatch();
  const ownerId = useOwnerId();
  const taskDefaults = useTaskDefaults();
  const blankTask = useMemo(() => getDefaultTask({
    ownerId,
    timestamp: taskDefaults[DUE_DATE],
    relativeReminder: taskDefaults[RELATIVE_REMINDERS],
    reminder: taskDefaults[REMINDERS]
  }), [ownerId, taskDefaults]);
  const handleSaveTask = useCallback(taskRecord => {
    return postTaskRecord(taskRecord).then(createdTask => {
      dispatch(addNewTask({
        task: createdTask,
        activeViewId,
        searchKey: searchKey !== null && searchKey !== void 0 ? searchKey : undefined
      }));
      const title = getProperty(createdTask, TITLE);
      const taskId = getId(createdTask);
      const handleClick = () => {
        history.push(`${viewLink({
          taskId,
          viewId: activeViewId
        })}${queryParamsString}`);
      };
      //show an alert with go to task
      FloatingAlertStore.addAlert(getGoToCreatedTaskAlert({
        name: title,
        linkProps: {
          onClick: handleClick
        }
      }));
      triggerWootricSurvey();
    }, __error => addError({
      messageI18nKey: 'taskForm.error.createTaskFailed'
    }));
  }, [dispatch, activeViewId, searchKey, history, queryParamsString]);
  return /*#__PURE__*/_jsx(Panel, {
    width: 500,
    "data-selenium-test": "create-task-panel",
    children: /*#__PURE__*/_jsx(TaskFormAsync, {
      task: blankTask,
      edit: false,
      onSave: handleSaveTask,
      renderRhumbErrorMarker: renderRhumbErrorMarker,
      "data-test-id": "create-task-form",
      children: /*#__PURE__*/_jsx(NavMarker, {
        name: "CREATE_TASK_PANEL_LOADED"
      })
    })
  });
};
export default CreateTaskPanel;